import { render, staticRenderFns } from "./MemberAgeReport.vue?vue&type=template&id=529d7ee0"
import script from "./MemberAgeReport.vue?vue&type=script&lang=js"
export * from "./MemberAgeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports